import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return {
    /**
     * @description 待办事项
     */
    todoList: function todoList() {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
                return _context.abrupt("return", request({
                  url: '/index/todoList',
                  data: data
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
     * @description 实时数据
     * @param {Object} data
     */
    realTimeData: function realTimeData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/index/realTimeData',
        data: data
      });
    },

    /**
     * @description 消息详情
     * @param {Object} data
     */
    messageDetails: function messageDetails() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/index/messageDetails',
        data: data
      });
    },

    /**
     * @description 消息列表
     * @param {Object} data
     */
    messages: function messages() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/index/messages',
        data: data
      });
    },

    /**
     * @description 已读全部消息
     * @param {Object} data
     */
    readAllMsg: function readAllMsg() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/index/readAllMsg',
        data: data
      });
    }
  };
});